/**
 * PostHog session replay masks all inputs by default. Add this class to an
 * input — or any ancestor — to record its real value. Only use on inputs
 * that can never hold PII (e.g. search boxes).
 */
export const PH_UNMASK_CLASS = "ph-unmask";
